import script from "./AdvertiserDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./AdvertiserDetails.vue?vue&type=script&setup=true&lang=js"

import "./AdvertiserDetails.vue?vue&type=style&index=0&id=46e91281&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46e91281"]])

export default __exports__